module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('header', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('button', {
    staticClass: "navbar-toggler mobile-toggler hidden-lg-up",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    staticStyle: {
      "padding": "0",
      "text-align": "center",
      "background-image": "none"
    },
    attrs: {
      "to": "/retailer-execution",
      "exact": ""
    }
  }, [(!_vm.logo) ? _c('span', [_vm._v(_vm._s(_vm.company_name))]) : _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-md-down float-xs-left"
  }, [_vm._m(0), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
    staticClass: "nav-item",
    staticStyle: {
      "padding": "0 20px",
      "padding-left": "40px"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'active ': _vm.is_active_menu('retail execution')
    },
    attrs: {
      "to": {
        path: '/retailer-execution',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_vm._v("\n                    Retail Execution\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.company_plan === 2 || _vm.company_plan === 3 || _vm.company_plan === 4))) ? _c('li', {
    staticClass: "nav-item",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'active ': _vm.is_active_menu('stock-management-dashboard')
    },
    attrs: {
      "to": "/stock-management-dashboard",
      "exact": ""
    }
  }, [_vm._v("\n                      Stock Management\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.company_plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'active ': _vm.is_active_menu('sales dashboard')
    },
    attrs: {
      "to": {
        path: '/sales-dashboard',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_vm._v("\n                    Sales\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav float-xs-right"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [(_vm.is_master === true || _vm.is_manager === true) ? _c('router-link', {
    staticClass: "nav-link avatar",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "to": {
        path: '/settings',
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-settings icons font-2xl",
    staticStyle: {
      "color": "#25bdad"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        path: '/profile',
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile\n                    ")]), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        path: '/settings',
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" Settings\n                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 1)], 1)])], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler layout-toggler",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("☰")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link avatar",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "icon-user icons font-2xl",
    staticStyle: {
      "color": "#25bdad"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52186acf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1418
// module chunks = 260